import { Link } from 'react-router-dom';
import { Stack, Typography, Button, Box } from '@mui/material';
import { IllustrationRestricted } from './illustrations/IllustrationRestricted';

export const RestrictedAccess = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        minHeight: '90vh',
        backgroundColor: '#ffffff',
      }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        spacing={3}
      >
        <IllustrationRestricted />
        <Stack
          justifyContent="center"
          alignItems="center"
          spacing={1}
        >
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, fontSize: '27px' }}
          >
            Your 14-day free trial has expired
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 300, fontSize: '16px', whiteSpace: 'pre-line', textAlign: 'center' }}
          >
            {`You no longer have access to the app.\nAdd your billing account to continue using Agents Space.`}
          </Typography>
        </Stack>
        <Button
          component={Link}
          to="/"
          variant="contained"
          sx={{
            backgroundColor: '#a7c4e5',
            color: '#3b6fac',
            boxShadow: 'none',
            borderRadius: 1.3,
            '&:hover': { backgroundColor: '#a7c4e5', color: '#3b6fac' },
          }}
        >
          Back to Homepage
        </Button>
      </Stack>
    </Box>
  );
};
